import { useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { useRouteError } from 'react-router-dom'
import Error500 from '../500'
import Loader from '../../Loader'

interface RouteError extends Error {
  statusText?: string
  status?: number
}
const ReloadingWrapper = styled.div`
  display: 'flex';
  justify-content: 'center';
  align-items: 'center';
  height: '100vh';
`

const DYNAMIC_IMPORT_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Loading chunk',
  'Loading CSS chunk',
  'ChunkLoadError',
] as const

const RELOAD_DELAY = 100 // ms

const DynamicImportErrorBoundary = () => {
  const error = useRouteError() as RouteError

  const isDynamicImportError = useMemo(() => {
    if (!error) return false

    const { message, name } = error

    return DYNAMIC_IMPORT_ERROR_PATTERNS.some(
      pattern => message?.includes(pattern) || name === pattern
    )
  }, [error])

  useEffect(() => {
    if (isDynamicImportError) {
      const timeoutId = setTimeout(() => {
        window.location.reload()
      }, RELOAD_DELAY)

      return () => clearTimeout(timeoutId)
    }
  }, [isDynamicImportError])

  if (isDynamicImportError) {
    return <ReloadingSpinner />
  }

  return <Error500 />
}

const ReloadingSpinner = () => (
  <ReloadingWrapper>
    <Loader color='var(--color-velvet)' size='40px' />
  </ReloadingWrapper>
)

export default DynamicImportErrorBoundary
